import {
  getAccountsPageUrl,
  getContactPageUrl,
  getDashboardPageUrl,
  getDocumentsPageUrl,
  getFilesPageUrl,
  getInvoicingPageUrl,
  getSettingsPageUrl,
  getTravelAndExpensesPageUrl
} from '@constants/urls'

export type BusinessHomeAccess = {
  dashboard: boolean
  bookkeeping: boolean
  invoicing: boolean
  files: boolean
  contacts: boolean
  accounts: boolean
  expenseClaims: boolean
}

/**
 * First-match landing path when the user opens `/{slug}` without dashboard access.
 * Order matches main navigation: documents → invoicing → files → contacts → accounts → travel and expenses → settings.
 */
export const getBusinessHomePath = (slug: string, access: BusinessHomeAccess): string => {
  if (access.dashboard) return getDashboardPageUrl(slug)
  if (access.bookkeeping) return getDocumentsPageUrl(slug)
  if (access.invoicing) return getInvoicingPageUrl(slug)
  if (access.files) return getFilesPageUrl(slug)
  if (access.contacts) return getContactPageUrl(slug)
  if (access.accounts) return getAccountsPageUrl(slug)
  if (access.expenseClaims) {
    return getTravelAndExpensesPageUrl(slug, { tab: 'claims' })
  }
  return getSettingsPageUrl(slug)
}
